module.exports = __webpack_public_path__ + "static/media/favicon.b4ae7edb.ico";